// DEPENDECIES
import React, { useState, useEffect } from 'react';
import { connect } from "react-redux";
import { useFormik } from "formik";
// COMPONENTS
import MUIDataTable from "mui-datatables";
import { Button, Modal, Form } from "react-bootstrap";
import SVG from "react-inlinesvg";
// CUSTOM COMPONENTS
import * as alert from "../../../redux/alertSnackBarRedux";
import * as confirmModal from "../../../redux/confirmModalRedux";
// SERVICES AND HELPERS
import * as settingService from "../../../services/management/settingService";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import SettingValidator from "../../../helpers/validators/SettingValidator";
import { getInputClasses } from "../../../helpers/helper";

var initialSetting = {
    id: 0,
    key: '',
    value: ''
}

const SettingsListingPage = (props) => {
    const { showAlert, showConfirmModal, hideConfirmModal } = props;
    const [data, setData] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedSetting, setSelectedSetting] = useState(initialSetting);

    useEffect(() => {
        loadTableData();
    }, [])

    const loadTableData = () => {
        settingService.getSettings().then(res => {
            setData(res);
        }).catch((ex) => {
            showAlert({ message: ex.message, variant: "error" });
        });
    }

    const editSetting = (id) => {
        settingService.getSettingById(id).then(res => {
            setSelectedSetting(res);
            setIsModalOpen(true);
        })
    }

    const deleteSetting = (id) => {
        settingService.deleteSetting(id).then(res => {
            showAlert({ message: res.message, variant: "success" });
            loadTableData();
            hideConfirmModal();
        })
    }

    const columns = [
        {
            name: "id",
            label: "Actions",
            options: {
                filter: false,
                sort: false,
                width: 15,
                download: false,
                setCellProps: () => ({ style: { width: "20%" } }),
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <>
                            <button
                                className="btn btn-sm btn-info font-weight-bold py-2 px-3 px-xxl-5"
                                onClick={() => editSetting(data[dataIndex].id)}
                            >
                                Edit
                            </button> &nbsp;
                            <button
                                onClick={() => showConfirmModal({
                                    title: "Delete Setting",
                                    text: "Are you sure you want to delete this setting?",
                                    rightBtnText: "Confirm",
                                    btnAction: () => deleteSetting(data[dataIndex].id)
                                })}
                                className="btn btn-sm btn-danger font-weight-bold py-2 px-3 px-xxl-5 my-1"
                            >
                                Delete
                            </button>
                        </>
                    );
                }
            },

        },
        {
            name: "key",
            label: "Key",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "value",
            label: "Value",
            options: {
                filter: true,
                sort: true,
            }
        }
    ];

    const handleModalClose = () => {
        setIsModalOpen(false);
        setSelectedSetting(initialSetting);
        formik.resetForm();
    }

    const saveSetting = (values, setStatus, setSubmitting) => {
        settingService.saveSetting(values).then(res => {
            showAlert({ message: res.message, variant: "success" });
            loadTableData();
            handleModalClose();
        }).catch((ex) => {
            showAlert({ message: ex.message, variant: "error" });
        })
    }


    const formik = useFormik({
        enableReinitialize: true,
        initialValues: selectedSetting,
        validationSchema: SettingValidator,
        onSubmit: (values, { setStatus, setSubmitting }) => {
            saveSetting(values, setStatus, setSubmitting);
        }
    });

    return (
        <div className="row" >
            <Modal centered size="lg" show={isModalOpen} onHide={handleModalClose}>
                <form className="card card-custom" onSubmit={formik.handleSubmit}>
                    <Modal.Header closeButton>
                        <Modal.Title>Setting</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="form">
                            <div className="form-group row">
                                <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                    Key
                                    </label>
                                <div className="col-lg-9 col-xl-9">
                                    <div className="input-group input-group-lg input-group-solid">
                                        <input
                                            placeholder="Start typing..."
                                            className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "key")}`}
                                            name="key"
                                            {...formik.getFieldProps("key")}
                                        />
                                    </div>
                                    {formik.touched.key && formik.errors.key ? (
                                        <div className="invalid-feedback display-block">
                                            {formik.errors.key}
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                    Value
                                    </label>
                                <div className="col-lg-9 col-xl-9">
                                    <div className="input-group input-group-lg input-group-solid">
                                        <Form.Control as="textarea" rows="10"
                                            placeholder="Start typing..."
                                            className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "value")}`}
                                            name="value"
                                            {...formik.getFieldProps("value")}
                                        />
                                    </div>
                                    {formik.touched.value && formik.errors.value ? (
                                        <div className="invalid-feedback display-block">
                                            {formik.errors.value}
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleModalClose}>
                            Close
                        </Button>
                        <button
                            type="submit"
                            className="btn btn-success mr-2"
                            disabled={
                                formik.isSubmitting || (formik.touched && !formik.isValid)
                            }
                        >
                            Save
                        {formik.isSubmitting}
                        </button>
                    </Modal.Footer>
                </form>
            </Modal>
            <div className="col-lg-12 col-xxl-12">
                <div className={`card card-custom card-stretch gutter-b}`}>
                    <div className="card-header border-0 py-5">
                        <h3 className="card-title align-items-start flex-column">
                            <span className="card-label font-weight-bolder text-dark">
                                Settings
                            </span>
                            <span className="text-muted mt-3 font-weight-bold fz-xs">
                                View and Manage Settings
                            </span>
                        </h3>
                        <div className="card-toolbar">
                            <button
                                onClick={() => setIsModalOpen(true)}
                                className="btn btn-success font-weight-bolder font-size-sm mr-3"
                            >
                                <span className="svg-icon svg-icon-lg svg-icon-white">
                                    <SVG
                                        src={toAbsoluteUrl(
                                            "/media/svg/icons/Code/Plus.svg"
                                        )}
                                    />
                                </span> Add Setting
                            </button>
                        </div>
                    </div>
                    <div className="container-fluid">
                        <MUIDataTable
                            data={data}
                            columns={columns}
                            options={{
                                rowsPerPage: 25,
                                rowsPerPageOptions: [10, 15, 20, 25, 30, 35, 40, 45, 50, 100],
                                selectableRows: 'none'
                            }}
                        />
                    </div>
                </div>
            </div>
        </div >
    )
}

export default connect(null, { ...alert.actions, ...confirmModal.actions })(SettingsListingPage);